<template>
<div>
    <v-container fluid grid-list-md px-0>
        <v-layout row wrap>
            <v-flex xs11>
              <v-snackbar
                    v-model="alert" 
                    color="green lighten-2" 
                    class="white--text" 
                    top outlined dense 
                    type="success" text>
                    {{ message }}
                    <v-btn color="white" text  @click="alert = false">  <v-icon color="maroon">mdi-close</v-icon></v-btn>
                </v-snackbar>
                 <v-snackbar
                    v-model="alert_error" 
                    color="red lighten-2" 
                    class="white--text" 
                    top outlined dense
                    type="error" text>
                    {{ error }}
                    <v-btn color="white" text  @click="alert_error = false"> Close</v-btn>
                </v-snackbar>
             </v-flex>
            <v-flex xs11>
                <v-card outlined class="pa-2" height="100%">
                    <div>
                        <v-layout row wrap fill-height class="light-bg pa-2 header">
                            <v-flex xs6 sm7>
                                <p class="text-color">Create User</p>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex sm12 md12>
                                <v-form id="addUser" 
                                @submit.prevent="validateBeforeSubmit('addUser')" 
                                data-vv-scope="addUser" 
                                ref="userUser" 
                                autocomplete="off"
                                v-model="valid">
                                    <v-card-text>
                                        <v-container fluid grid-list-md style="padding: 0px 0px 0px 0px">
                                            
                                            
                                            <v-layout row wrap>
                                                <v-flex xs12 sm12 md5>
                                                    <v-text-field name="username" 
                                                    
                                                    id="username" 
                                                    v-model="user_object.username"  
                                                    v-validate="'required'"
                                                    :error-messages="errors.collect('addUser.username')">
                                                    <template v-slot:label >
                                                    Username <span style="color:red"> * </span>
                                                    </template>     
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6 md5 offset-md-1>
                                                    <v-text-field name="password"  id="password" v-model="user_object.password" v-validate="'required'" :error-messages="errors.collect('addUser.password')">
                                                    <template v-slot:label >
                                                    Password <span style="color:red"> * </span>
                                                    </template> 
                                                    </v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex xs12 sm12 md5>
                                                    <v-autocomplete 
                                                    :items="role_list" 
                                                    name="Role" 
                                                    v-model="user_object.role" 
                                                    return-object 
                                                    item-text="display_name" 
                                                    item-value="id" 
                                                    clearable 
                                                    autocomplete="off"
                                                    :disabled="office_disabled" 
                                                    v-validate="'required'" 
                                                    :error-messages="errors.collect('addUser.Role')">
                                                    <template v-slot:label >
                                                    Roles <span style="color:red"> * </span>
                                                    </template>
                                                    </v-autocomplete>
                                                </v-flex>
                                                <v-flex xs12 sm12 md5 offset-md-1 v-if="role.name == 'office_admin'">
                                                    <v-autocomplete 
                                                    :items="office_list" 
                                                    name="Office" 
                                                    v-model="user_object.office_id" 
                                                    :search-input.sync="user_object.office_search" 
                                                    :disabled="office_disabled" 
                                                    item-text="name" 
                                                    autocomplete="off"
                                                    item-value="id" 
                                                    clearable 
                                                    v-validate="'required'"
                                                    :error-messages="errors.collect('addUser.Office')">
                                                    <template v-slot:label >
                                                    Office <span style="color:red"> * </span>
                                                    </template>
                                                    </v-autocomplete>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="primary" small :loading="loading" :disabled="!valid" type="submit">Add</v-btn>
                                        <v-btn text small to="/users">Cancel</v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-flex>
                        </v-layout>
                    </div>
                </v-card>
            </v-flex>
        </v-layout>
       
    </v-container>
</div>
</template>

<script>
export default {
    watch: {
    
        "user_object.office_search": {
            handler(val) {
                if (val) {
                    this.office_list=[];
                    if (val.length >= 3) {
                        this.getOfficeList();
                    }
                }

            }
        },
        "user_object.role": {
            deep: true,
            handler(val) {
                if (val) {
                    this.role = val;
                    // if (val.name == 'reception_user') {

                    //     this.user_object.username = 'reception.'.concat(this.user_object.first_name);
                    // } else if (val.name == 'super_admin') {

                    //     this.user_object.username = 'admin.society';
                    // } else if (val.name == 'society_admin') {

                    //     this.user_object.username = 'admin.super';
                    // } else if (val.name == 'office_admin') {

                    //     this.user_object.username = 'admin.'.concat(this.user_object.first_name);
                    // }

                }

            }
        },
    },
    methods: {

        validateBeforeSubmit: function (scope) {
            this.$validator.validateAll(scope).then(result => {
                if (result) {
                    this[scope]();
                }
            });
        },
        addUser: function () {
            this.loading = true;
            let new_user = Object.assign({}, this.user_object);

            axios.post(`${process.env.VUE_APP_API_URL}/api/users`, new_user).then((response) => {
                 this.loading = false;
                if (response.data.status == 1) {
                    this.$router.push({name: 'users', params:{
                        success_message:'User Created Successfully'
                    }});
                    
                    
                }
                if (response.data.status == 0) {
                    this.alert_error=true;
                    this.error = 'Error Occured';
                    this.loading = false;
                }
            }).catch((error) => {
                this.error = error;
            }).finally(() => {

            });
        },
        getOfficeList: function () {
            axios.get(`${process.env.VUE_APP_API_URL}/api/offices/list`, {
                params: {
                    query_string: this.user_object.office_search
                }
            }).then((response) => {
                if (response.data.status == 1) {
                    this.office_list = response.data.office_list;

                }
            }).catch((error) => {

            }).finally(() => {
                {

                }
            });

        },
        getoffice() {
            axios.get(`${process.env.VUE_APP_API_URL}/api/offices/` + this.$route.params.office_id)
                .then(response => { console.log(response);
                    if (response.data.status == 1) {

                        this.user_object.role = {
                            'name': 'office_admin',
                            'display_name': 'Office Admin',
                            'id': '2'
                        };
                        this.role = this.user_object.role;
                        this.user_object.office_id = {
                            'name': response.data.office_details.name,
                            'id': response.data.office_details.id
                        }
                        

                        this.office_disabled = true;
                    }
                }).catch((error) => {
                    console.log(error);
                }).finally(() => {
                    {

                    }
                });

        },
        getRoleList: function () {
            this.role = localStorage.getItem('visitor_management_role');
            if (this.role == "Office Admin") {
                this.role_list = [{
                    'name': 'office_admin',
                    'display_name': 'Office Admin',
                    'id': '2'
                }]

            } else if (this.role == "Society Admin") {

                this.role_list = [{
                        'name': 'reception_user',
                        'display_name': 'Reception User',
                        'id': '3'
                    },
                    {
                        'name': 'society_admin',
                        'display_name': 'Society Admin',
                        'id': '4'
                    },
                    {
                        'name': 'office_admin',
                        'display_name': 'Office Admin',
                        'id': '2'
                    }
                ]

            } else if (this.role == "Super Admin") {

                this.role_list = [{
                        'name': 'reception_user',
                        'display_name': 'Reception User',
                        'id': '3'
                    },
                    {
                        'name': 'office_admin',
                        'display_name': 'Office Admin',
                        'id': '2'
                    },
                    {
                        'name': 'super_admin',
                        'display_name': 'Super Admin',
                        'id': '1'
                    },
                    {
                        'name': 'society_admin',
                        'display_name': 'Society Admin',
                        'id': '4'
                    }
                ]

            }
        }
    },
    data: () => {
        return {
            user_object: {
                username: '',
                office_id: '',
                role:'',
                password: ''
            },
            error: '',
            role: '',
            super_admin: false,
            reception_user: true,
            society_admin: false,
            valid: false,
            office_list: [],
            loader: null,
            loading: false,
            role_list: [],
            office_disabled: false,
            message:'',
            alert: false,
            alert_error:false

        }
    },
    mounted() {
        this.office_list=[];
        if (this.$route.params.office_id != null) {
            this.getoffice();
        }
        this.getRoleList();
    },
};
</script>

<style scoped>
.theme--light.v-card {
    background-color: #FFFFFF;
    color: rgba(0, 0, 0, 0.87);
    padding: 5%;
}
</style>